var _circle, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReaction2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1461",
    "data-name": "Group 1461",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.916,
    height: 22.916,
    viewBox: "0 0 22.916 22.916",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_77",
    "data-name": "Ellipse 77",
    cx: 11.458,
    cy: 11.458,
    r: 11.458,
    transform: "translate(0 0)",
    fill: "#ffc905"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1459",
    "data-name": "Group 1459",
    transform: "translate(6.386 7.272)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_78",
    "data-name": "Ellipse 78",
    cx: 1.085,
    cy: 1.927,
    rx: 1.085,
    ry: 1.927,
    transform: "translate(7.973)",
    fill: "#242424"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_79",
    "data-name": "Ellipse 79",
    cx: 1.085,
    cy: 1.927,
    rx: 1.085,
    ry: 1.927,
    fill: "#242424"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1460",
    "data-name": "Group 1460",
    transform: "translate(6.553 14.968)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1894",
    "data-name": "Path 1894",
    d: "M2403.83,500.067a5.08,5.08,0,0,1-3.9-1.494,3.788,3.788,0,0,1-.912-1.621l1.749-.389,0-.013c.045.177.516,1.726,3.07,1.726,2.58,0,3.115-1.576,3.167-1.756l0,.012,1.734.451C2408.7,497.108,2407.88,500.067,2403.83,500.067Z",
    transform: "translate(-2399.014 -496.519)",
    fill: "#242424"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReaction2);
export default __webpack_public_path__ + "static/media/reaction2.d8c7d778c63e8955383693ef87bfd33e.svg";
export { ForwardRef as ReactComponent };